<p-toast position="top-right"></p-toast>

<!--
		Tres fichas, no cinco tarjetas. «Facturas del mes» y «Monto del mes» se fueron: son exactamente
		la casilla «Facturado» del embudo, dos centímetros más arriba, y el mismo número dos veces en una
		pantalla obliga a comprobar si de verdad es el mismo. Las tres que quedan no están en el embudo y
		no son cifras contables: son TRABAJO pendiente, así que se dibujan como lo que son.
	-->
<div class="inv-chips" *ngIf="summary">
  <span class="inv-chip" [class.is-warn]="(summary.pendientes || 0) > 0">
    <i class="fa-solid fa-clock"></i><b>{{ summary.pendientes || 0 }}</b> pendientes de archivo
    <em>referencias sin PDF/XML</em>
  </span>
  <span class="inv-chip" [class.is-warn]="(summary.pendientesComplemento || 0) > 0">
    <i class="fa-solid fa-receipt"></i><b>{{ summary.pendientesComplemento || 0 }}</b> pendientes de complemento
    <em>PPD pagadas sin REP</em>
  </span>
  <span class="inv-chip" [class.is-bad]="(summary.canceladas || 0) > 0">
    <i class="fa-solid fa-rotate"></i><b>{{ summary.canceladas || 0 }}</b> canceladas o refacturadas
    <em>en el mes</em>
  </span>
</div>

<!--
		 El desglose por concepto: UNA BARRA, no una dona.

		 La dona pedía 330 px de alto —dibujo, leyenda y lista al lado— para decir tres cifras. Y medía
		 por CONTEO de facturas, no por importe: una gestoría de $8,500 se veía igual de grande que un
		 enganche de $1.3M, así que el dibujo contradecía a la lista que tenía pegada. La barra apilada
		 mide por importe, que es lo que se desglosa, y cabe en un renglón.
	-->
<div class="inv-conceptos" *ngIf="conceptos.length; else sinConcepto">
  <div class="ic-head">
    <span class="ic-title">Por concepto</span>
    <span class="ic-total"
      >{{ summary?.facturasDelMes?.amount | currency }} <em>en {{ summary?.facturasDelMes?.count }} CFDI</em></span
    >
  </div>

  <div class="ic-bar" role="img" [attr.aria-label]="'Reparto de lo facturado entre ' + conceptos.length + ' conceptos'">
    <span
      *ngFor="let c of conceptos"
      [style.width.%]="c.pct"
      [style.background]="c.color"
      [pTooltip]="c.label"
      tooltipPosition="top"
    ></span>
  </div>

  <ul class="ic-list">
    <li *ngFor="let c of conceptos">
      <i [style.background]="c.color"></i>
      <b>{{ c.label }}</b>
      <span class="ic-amt">{{ c.amount | currency }}</span>
      <em>{{ c.count }}</em>
    </li>
  </ul>
</div>

<ng-template #sinConcepto>
  <p class="inv-vacio"><i class="fa-solid fa-chart-simple"></i> Sin facturas emitidas en {{ monthLabel }}.</p>
</ng-template>

<!--
		Tabla propia, NO la genérica: doce columnas y seis filtros para contestar «¿qué me falta hacer?»,
		que ninguna columna contestaba sola. Ver `invoices-table.component.ts`. La genérica no se toca:
		la usan muchas pantallas.
	-->
<app-invoices-table #invoicesTable [monthLabel]="monthLabel" (accion)="onRowAction($event)"></app-invoices-table>

<!-- ───────────── Modal: Carga masiva ───────────── -->
<app-invoices-upload-dialog [(visible)]="showUpload" (completed)="onUploadCompleted()"></app-invoices-upload-dialog>

<!-- ───────────── Modal: Complementos de pago (REP) ───────────── -->
<app-invoice-complements-dialog
  [(visible)]="showComplements"
  [invoice]="complementsInvoice"
  (changed)="onComplementsChanged()"
></app-invoice-complements-dialog>

<!-- ───────────── Modal: Refacturar ───────────── -->
<p-dialog
  [(visible)]="showRefacturar"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '480px' }"
  header="Refacturar factura"
>
  <div class="rf-modal-form">
    <div class="field">
      <label>UID actual</label>
      <input pInputText type="text" [value]="refacturarCurrentUid" disabled />
    </div>
    <div class="field">
      <label for="rfNewFolio">Nuevo Folio Fiscal</label>
      <input
        id="rfNewFolio"
        pInputText
        type="text"
        [(ngModel)]="refacturarNewFolioFiscal"
        placeholder="Serie+Folio del nuevo CFDi (ej. A1198) — o adjunta su PDF/XML"
      />
      <small class="block mt-1 text-500"
        >Si adjuntas el PDF/XML abajo, el Folio Fiscal y el UID se leen del archivo; deja este campo vacío.</small
      >
    </div>
    <div class="field">
      <label for="rfReason">Motivo (opcional)</label>
      <textarea
        id="rfReason"
        pInputTextarea
        [(ngModel)]="refacturarReason"
        rows="2"
        [maxlength]="500"
        placeholder="Motivo de la refacturación"
      ></textarea>
    </div>
    <div class="field">
      <label>Archivos de la nueva factura (opcional; también por carga masiva)</label>
      <div class="flex gap-2 flex-wrap">
        <label class="rf-mini-file"
          ><i class="pi pi-file-pdf"></i> {{ refacturarPdf?.name || 'Seleccionar PDF'
          }}<input type="file" accept=".pdf" hidden (change)="onRefacturarPdf($event)"
        /></label>
        <label class="rf-mini-file"
          ><i class="pi pi-file"></i> {{ refacturarXml?.name || 'Seleccionar XML'
          }}<input type="file" accept=".xml" hidden (change)="onRefacturarXml($event)"
        /></label>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      (click)="showRefacturar = false"
      [disabled]="refacturando"
    ></button>
    <button
      pButton
      type="button"
      label="Refacturar"
      icon="pi pi-refresh"
      (click)="confirmRefacturar()"
      [disabled]="refacturando || (!refacturarNewFolioFiscal.trim() && !refacturarPdf && !refacturarXml)"
      [loading]="refacturando"
    ></button>
  </ng-template>
</p-dialog>

<!-- ───────────── Modal: Cancelar ───────────── -->
<p-dialog
  [(visible)]="showCancel"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '440px' }"
  header="Cancelar factura"
>
  <div class="rf-modal-form">
    <div class="warn-box">
      <i class="fa-solid fa-exclamation-triangle"></i>
      <span
        >La factura <strong>{{ cancelUid }}</strong> quedará cancelada. Se conserva el historial; el periodo quedará sin factura
        activa.</span
      >
    </div>
    <div class="field">
      <label for="cnReason">Motivo *</label>
      <textarea
        id="cnReason"
        pInputTextarea
        [(ngModel)]="cancelReason"
        rows="3"
        [maxlength]="500"
        placeholder="Motivo de la cancelación"
      ></textarea>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cerrar" class="p-button-text" (click)="showCancel = false" [disabled]="cancelando"></button>
    <button
      pButton
      type="button"
      label="Confirmar cancelación"
      icon="pi pi-ban"
      class="p-button-danger"
      (click)="confirmCancel()"
      [disabled]="cancelando || !cancelReason.trim()"
      [loading]="cancelando"
    ></button>
  </ng-template>
</p-dialog>

<!-- ───────────── Modal: Central de Facturas (layout de emisión) ───────────── -->
<p-dialog
  [(visible)]="showPendingExport"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '460px' }"
  header="Central de Facturas"
>
  <div class="rf-modal-form">
    <div class="warn-box" style="background: #eef4ff; border-color: #c7dbff; color: #1e40af">
      <i class="fa-solid fa-circle-info"></i>
      <span>Genera el reporte con una fila por concepto de cada arrendamiento <strong>Activo</strong> con facturación configurada.</span>
    </div>
    <div class="field">
      <label for="peFolio">Folio inicial</label>
      <input
        id="peFolio"
        pInputText
        type="text"
        class="w-full"
        [value]="pendingFolioLoading ? 'Calculando…' : (pendingStartFolio ?? '—')"
        readonly
      />
      <small class="block mt-1 text-500">Autocalculado a partir de la última factura registrada. Ya no se captura manualmente.</small>
      <small *ngIf="pendingFolioSource === 'seed'" class="block mt-1" style="color: #b45309"
        ><i class="fa-solid fa-triangle-exclamation"></i> Aún no hay facturas registradas: se usa el folio semilla. Verifica que sea
        correcto antes de emitir.</small
      >
    </div>
    <div class="field">
      <label for="peMonth">Mes / Año objetivo</label>
      <p-calendar
        inputId="peMonth"
        [(ngModel)]="pendingMonth"
        view="month"
        dateFormat="mm/yy"
        [readonlyInput]="true"
        [showIcon]="true"
        styleClass="w-full"
      ></p-calendar>
      <small class="block mt-1 text-500"
        >Alimenta el texto por defecto de Comentarios (RENTA {{ '{' }}MES{{ '}' }} {{ '{' }}AÑO{{ '}' }}) cuando el concepto no tiene
        comentario propio.</small
      >
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cerrar"
      class="p-button-text"
      (click)="showPendingExport = false"
      [disabled]="pendingExporting"
    ></button>
    <button
      pButton
      type="button"
      label="Descargar"
      icon="fa-solid fa-file-arrow-down"
      (click)="confirmPendingExport()"
      [disabled]="pendingExporting"
      [loading]="pendingExporting"
    ></button>
  </ng-template>
</p-dialog>

<!-- ───────────── Modal: Historial de facturación ───────────── -->
<p-dialog
  [(visible)]="showHistory"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '640px' }"
  [header]="historyTitle || 'Historial de facturación'"
>
  <div class="inv-history-list">
    <div *ngIf="loadingHistory" class="text-color-secondary text-center p-3">Cargando…</div>
    <div class="inv-history-item" *ngFor="let inv of historyInvoices">
      <div class="inv-history-head">
        <span class="inv-history-folio">{{ inv.folioFiscal || '—' }}</span>
        <p-tag [value]="historyStatusLabel(inv.status)" [severity]="historyStatusSeverity(inv.status)"></p-tag>
        <span class="inv-history-amount">{{ inv.amount != null ? (inv.amount | currency) : '—' }}</span>
        <span class="inv-history-date">{{ inv.issueDate ? (inv.issueDate | date: 'dd/MM/yyyy') : '—' }}</span>
        <span class="inv-history-files">
          <button
            pButton
            type="button"
            pTooltip="Descargar PDF"
            tooltipPosition="top"
            class="p-button-text p-button-danger p-button-sm"
            icon="fa-solid fa-file-pdf"
            [disabled]="!inv.pdfUrl || isDownloadingHistory(inv, 'pdf')"
            (click)="downloadHistoryFile(inv, 'pdf')"
          ></button>
          <button
            pButton
            type="button"
            pTooltip="Descargar XML"
            tooltipPosition="top"
            class="p-button-text p-button-info p-button-sm"
            icon="fa-solid fa-file-code"
            [disabled]="!inv.xmlUrl || isDownloadingHistory(inv, 'xml')"
            (click)="downloadHistoryFile(inv, 'xml')"
          ></button>
        </span>
      </div>
      <div class="inv-history-reason" *ngIf="inv.cancelReason">
        <i class="pi pi-info-circle"></i> <strong>Motivo:</strong> {{ inv.cancelReason }}
      </div>
      <div class="inv-history-link" *ngIf="folioFiscalOf(inv.replaces)">
        Sustituye a <strong>{{ folioFiscalOf(inv.replaces) }}</strong>
      </div>
      <div class="inv-history-link" *ngIf="folioFiscalOf(inv.replacedBy)">
        Reemplazada por <strong>{{ folioFiscalOf(inv.replacedBy) }}</strong>
      </div>
    </div>
    <div *ngIf="!loadingHistory && !historyInvoices.length" class="text-color-secondary text-center p-3">Sin historial.</div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cerrar" class="p-button-text" (click)="showHistory = false"></button>
  </ng-template>
</p-dialog>

<!-- ───────────── Modal: Cargar (completar factura PENDING) ───────────── -->
<p-dialog
  [(visible)]="showUploadSingle"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '480px' }"
  header="Cargar factura pendiente"
>
  <div class="rf-modal-form">
    <div class="warn-box">
      <i class="fa-solid fa-circle-info"></i>
      <span
        >Factura <strong>{{ uploadFolioFiscal }}</strong
        >. Sube el PDF y/o XML <strong>tal como se descargan</strong> del portal (no los renombres). Del XML se toman el UID, el monto y la
        fecha.</span
      >
    </div>
    <!-- Si el archivo trae otro folio, se rechaza: el arreglo es corregir la referencia, y se ofrece aquí mismo. -->
    <button
      *ngIf="canEditRef"
      pButton
      type="button"
      class="p-button-text p-button-sm"
      icon="fa-solid fa-pen"
      label="¿El folio de la referencia está mal? Corrígelo"
      (click)="editRefFromUpload()"
    ></button>
    <div class="field">
      <label>Archivos (PDF / XML)</label>
      <div class="flex gap-2 flex-wrap">
        <label class="rf-mini-file"
          ><i class="pi pi-file-pdf"></i> {{ uploadPdf?.name || 'Seleccionar PDF'
          }}<input type="file" accept=".pdf" hidden (change)="onUploadPdf($event)"
        /></label>
        <label class="rf-mini-file"
          ><i class="pi pi-file"></i> {{ uploadXml?.name || 'Seleccionar XML'
          }}<input type="file" accept=".xml" hidden (change)="onUploadXml($event)"
        /></label>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      (click)="showUploadSingle = false"
      [disabled]="uploadingSingle"
    ></button>
    <button
      pButton
      type="button"
      label="Cargar"
      icon="pi pi-cloud-upload"
      (click)="confirmUploadSingle()"
      [disabled]="uploadingSingle || (!uploadPdf && !uploadXml)"
      [loading]="uploadingSingle"
    ></button>
  </ng-template>
</p-dialog>

<!-- ───────────── Modal: Editar referencia (factura PENDING cargada con datos equivocados) ───────────── -->
<p-dialog
  [(visible)]="showEditRef"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!savingRef"
  [style]="{ width: '520px' }"
  [breakpoints]="{ '600px': '95vw' }"
  header="Editar referencia"
>
  <div class="rf-modal-form" *ngIf="editRefInvoice">
    <div class="warn-box">
      <i class="fa-solid fa-circle-info"></i>
      <span
        >Los archivos se ligan <strong>por el folio fiscal</strong>. Corrige aquí lo que venía mal en el Excel de carga y después sube el
        PDF y el XML. Solo se puede mientras la factura esté <strong>sin archivo</strong>; con el CFDI ya ligado se usa Refacturar.</span
      >
    </div>
    <div class="field">
      <label for="er-folio">Folio fiscal</label>
      <input id="er-folio" pInputText class="w-full" [(ngModel)]="editRefFolio" placeholder="A1724" autocomplete="off" />
    </div>
    <div class="field">
      <label for="er-lease">Arrendamiento</label>
      <input
        id="er-lease"
        pInputText
        class="w-full"
        [(ngModel)]="editRefLease"
        placeholder="R-168-C25DEBCAA-0 o No. ID"
        autocomplete="off"
      />
    </div>
    <div class="field">
      <label for="er-tipo">Tipo</label>
      <p-dropdown
        inputId="er-tipo"
        styleClass="w-full"
        appendTo="body"
        [options]="editRefConcepts"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="editRefConcept"
      ></p-dropdown>
    </div>
    <div class="field">
      <label for="er-mes"
        >Mes <span class="text-color-secondary">{{ editRefConcept === 'RENT' ? '(la letra a la que va)' : '(mes contable)' }}</span></label
      >
      <input id="er-mes" pInputText class="w-full" [(ngModel)]="editRefMonth" placeholder="AAAA-MM" autocomplete="off" />
    </div>
    <div class="field" *ngIf="editRefConcept === 'MANAGEMENT_EXPENSE'">
      <label for="er-cat">Categoría</label>
      <p-dropdown
        inputId="er-cat"
        styleClass="w-full"
        appendTo="body"
        [options]="editRefCategories"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="editRefCategory"
        placeholder="Selecciona"
      ></p-dropdown>
    </div>
    <div class="field">
      <label for="er-motivo">Motivo <span class="text-color-secondary">(opcional, queda en la bitácora)</span></label>
      <input id="er-motivo" pInputText class="w-full" [(ngModel)]="editRefReason" autocomplete="off" />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" (click)="showEditRef = false" [disabled]="savingRef"></button>
    <button
      pButton
      type="button"
      label="Guardar"
      icon="fa-solid fa-check"
      (click)="confirmEditRef()"
      [disabled]="savingRef || !editRefFolio.trim() || !editRefLease.trim()"
      [loading]="savingRef"
    ></button>
  </ng-template>
</p-dialog>
